import 'firebase/auth'
import { authorize } from '@smartapp/auth-lib'
import { initializeApp } from 'firebase/app'
import * as firebaseui from 'firebaseui'
import { getAuth, onAuthStateChanged } from 'firebase/auth'
import i18n from './i18n'

const authConfig = {
  application: process.env.VUE_APP_APP_NAME,
  projectId: process.env.VUE_APP_FIREBASE_PROJECT_ID,
  country: process.env.VUE_APP_COUNTRY
}

const config = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: process.env.VUE_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_FIREBASE_DATABASE_URL,
  storageBucket: process.env.VUE_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
  ...authConfig
}


export let globalProperties = {}
initializeApp(config)

const ui = new firebaseui.auth.AuthUI(getAuth())
const auth = getAuth()

onAuthStateChanged(auth, async firebaseUser => {
  if (firebaseUser) {
    authorize(authConfig, firebaseUser, process.env.VUE_APP_BACKEND_AUTH)
      .then(({ user, roles }) => {
        globalProperties = { firebaseUser, user, roles }
        import(/* webpackChunkName: "createApp" */ './createApp').then(createApp => {
          createApp.createApp({ firebaseUser, user, roles })
        })
      })
      .catch(reason => {
        if (process.env.VUE_APP_BUILD_ENV !== 'production') console.warn(reason)
        if (reason.status === 403) {
          globalProperties = { firebaseUser, user: reason.user }
          import(/* webpackChunkName: "createApp" */ './createApp').then(createApp => {
            createApp.createForbiddenApp({ ...reason, firebaseUser })
          })
        } else {
          window.location.href = '/error.html'
        }
      })
  } else {
    ui.start('#firebase-ui', {
      signInFlow: 'popup',
      signInSuccessUrl: '/',
      signInOptions: [
        {
          provider: 'oidc.pass',
          buttonColor: '#E0001A',
          iconUrl: 'null',
          fullLabel: i18n.global.t('login-to'),
          providerName: process.env.VUE_APP_APP_NAME,
        }
      ]
    })
  }
})

